/* eslint-disable @typescript-eslint/no-unused-vars */
type Message = "GET_AUTH_TOKENS" | "AUTH_TOKENS_RESPONSE" | "CLOSE_WEBVIEW";

interface ReactNativeWebViewMessageResponse {
	data: any;
	message: Message;
}

const handleEventReceived = (event: any, cb?: (data: any) => void) => {
	console.log("HANDLE EVENT RECEIVED", event);
	try {
		const { message, data } = JSON.parse(
			event.data
		) as ReactNativeWebViewMessageResponse;

		cb && cb(data);
	} catch (error) {
		console.log("FAILED TO PARSE JSON", event.data);
	}
};

const WebViewMessageEventEmitter = {
	emit: (message: Message) => {
		console.log(`EMITTING EVENT ${message}....`);
		if (!window.ReactNativeWebView) return;

		window.ReactNativeWebView.postMessage(JSON.stringify({ message }));
	},

	addListener: (eventMessage: Message, cb: (data: any) => void) => {
		console.log(`RECEIVED EVENT ${eventMessage}....`);

		// Listener for IOS
		window.addEventListener("message", (event) =>
			handleEventReceived(event, cb)
		);

		// Listener for Android
		document.addEventListener("message", (event) =>
			handleEventReceived(event, cb)
		);
	},

	removeEventListener: (_eventMessage: Message) => {
		// Listener for IOS
		window.removeEventListener("message", (event) =>
			handleEventReceived(event)
		);

		// Listener for Android
		document.removeEventListener("message", (event) =>
			handleEventReceived(event)
		);
	},
};

export default WebViewMessageEventEmitter;
